import { CONTENT_POLICY_ERROR } from "../../../src/shared/constants";
export class ContentViolationError extends Error {
  constructor(message, cause) {
    super(message);
    this.name = "ContentViolation";
  }
}

export const CONTENT_POLICY_MESSAGE = (
  <div className="text-base leading-relaxed">
    This request violates our <a href="https://sudowrite.notion.site/Terms-and-Conditions-83ddd78e1ab04d9d88321a9ef7665925">Terms & Conditions</a> due to sexual content involving minors. If you
    believe you've received this notice in error, please <a href="mailto:hi@sudowrite.com">contact customer service</a>.
  </div>
);

export const CONTENT_GENERATION_FAILED_MESSAGE = "The writing model was unable to generate content for this request. No credits were charged. Please try again with different text.";

export const ABORT_MESSAGE = "The request was cancelled";

export const normalizeErrorMessage = (error) => {
  if (error?.message === CONTENT_POLICY_ERROR) {
    return CONTENT_POLICY_MESSAGE;
  }

  if (error?.message?.includes("abort")) {
    return ABORT_MESSAGE;
  }

  return error.message;
};
